module.exports = __webpack_public_path__ + "img/t4-2.b02989fa.svg";